import React, { ChangeEvent, HTMLProps } from 'react';
import { CheckboxIcon, CheckmarkIcon } from 'assets/icons';
import { classnames } from 'helpers/utils';
import styles from './checkbox.module.scss';

export enum CheckboxType {
  Checkbox = 'checkbox',
  Radio = 'radio',
}

type CheckboxProps = {
  disabled?: boolean;
  isChecked?: boolean;
  itemKey: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  disabledColor?: string;
  type?: CheckboxType;
};

const Checkbox: React.FC<CheckboxProps> & HTMLProps<HTMLInputElement> = ({
  isChecked = false,
  itemKey,
  disabled = false,
  onChange,
  disabledColor = '',
  type = CheckboxType.Checkbox,
}) => {
  const fillColor = isChecked ? disabledColor || '#4A92A3' : '#FFFFFF';

  const isDisabledColor = disabledColor
    ? styles.checkIconDisabled
    : styles.checkDisabled;

  return type === CheckboxType.Checkbox ? (
    <div>
      <input
        type="checkbox"
        name={itemKey}
        id={itemKey}
        onChange={(e) => onChange?.(e)}
        checked={isChecked}
        className={styles.custom}
        disabled={disabled}
      />
      <label htmlFor={itemKey} id={`checkbox-${itemKey}`}>
        <CheckboxIcon
          className={disabled ? styles.boxDisabled : styles.box}
          fill={fillColor}
        />
        {isChecked === true && (
          <CheckmarkIcon
            className={classnames(
              styles.check,
              disabled ? isDisabledColor : styles.checkEnabled,
            )}
          />
        )}
      </label>
    </div>
  ) : (
    <>
      <input
        type="radio"
        name={itemKey}
        id={itemKey}
        checked={isChecked}
        disabled={disabled}
        onChange={onChange}
        className={styles.customInputRadio}
      />
      <label htmlFor={itemKey} id={`radio-${itemKey}`} aria-label={itemKey}>
        <span className={styles.hiddenText}>{itemKey}</span>
        <div
          className={classnames(styles.radio, {
            [styles.checked]: isChecked,
            [styles.disabled]: disabled,
          })}
        >
          <div className={styles.radioInner} />
        </div>
      </label>
    </>
  );
};
export { Checkbox };
